import React, {
  useEffect,
  useRef,
  useState,
  FocusEvent,
  MouseEvent
} from 'react'
import classNames from 'classnames'
import { getIsFirefox } from '@toasttab/shared/src/utils/formUtils'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'
import { DateInputProps } from './DateInput.d'

const DateInput = ({
  variation,
  id,
  label,
  name,
  min,
  max,
  error,
  value,
  onChange,
  onBlur
}: DateInputProps) => {
  const [hasValue, setHasValue] = useState<boolean>(false)
  const dateInputElement = useRef<HTMLInputElement>(null)

  const isFirefox = getIsFirefox()

  useEffect(() => {
    if (isFirefox) {
      if (dateInputElement.current) {
        if (dateInputElement.current.value === '') {
          dateInputElement.current.type = 'text'
        }
        dateInputElement.current.addEventListener('onFocus', (event: any) => {
          event.target.type = 'date'
        })
        dateInputElement.current.addEventListener('blur', (event: any) => {
          if (event.target.value === '') {
            event.target.type = 'text'
          }
        })
      }
    }
  }, [])

  const dateWrapper = classNames({
    'w-full': true
  })
  const errorClassNames = classNames({
    'text-otl-error text-xs top-12 left-0':
      variation !== 'default' && variation !== 'inverse',
    'absolute top-full w-max flex flex-row font-sansPro items-center text-error text-xs font-semibold left-0 leading-4 xl:-mb-[6px] before:content-[""] before:bg-icon-warning-outline before:bg-center before:bg-contain before:bg-no-repeat before:w-4 before:h-4 before:block before:mr-2':
      variation === 'default',
    'absolute top-full w-max flex flex-row font-sansPro items-center text-white text-xs font-semibold left-0 leading-4 xl:-mb-[6px] before:content-[""] before:bg-icon-warning-outline-inverse before:bg-center before:bg-contain before:bg-no-repeat before:w-4 before:h-4 before:block before:mr-2':
      variation === 'inverse'
  })
  const inputClassNames = classNames({
    'border border-[1px] border-gray-50 shadow-none text-base box-border peer/input appearance-none':
      true,
    'bg-white text-lg placeholder:text-gray-50 text-default rounded-none font-sansPro focus:outline-none focus:shadow-text-input':
      true,
    'text-gray-50': !hasValue,
    'text-black': hasValue,
    'w-full': true,
    'px-2 py-[6px] border border-gray-50': true,
    'border border-otl-error border-error': error
  })

  const handleClick = (e: MouseEvent<HTMLInputElement>) => {
    try {
      e.currentTarget.showPicker()
    } catch (ex) {}
  }

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    if (e.currentTarget.value) {
      setHasValue(true)
    } else {
      setHasValue(false)
    }

    if (isFirefox) {
      if (dateInputElement && dateInputElement.current) {
        if (dateInputElement.current.value === '')
          dateInputElement.current.type = 'text'
      }
    }
  }

  const handleFocus = (e: FocusEvent<HTMLInputElement>) => {
    if (isFirefox) {
      if (dateInputElement && dateInputElement.current) {
        dateInputElement.current.type = 'date'
      }
    }
  }

  return (
    <div className={`${dateWrapper} date-wrapper`} data-testid='date-picker'>
      <input
        className={inputClassNames}
        data-testid='date-picker-input'
        id={id}
        max={max}
        min={min}
        name={name}
        onBlur={onBlur && handleBlur}
        onChange={onChange}
        onClick={handleClick}
        onFocus={handleFocus}
        placeholder={label}
        ref={dateInputElement}
        type='date'
        value={value}
      />

      <label className='hidden' data-testid='date-picker-label'>
        {label}
      </label>
      <div className='calendar-icon-wrapper' data-testid='date-picker-icon'>
        <img src={resolvePrefix('/svg/icon-calendar.svg')} alt='' />
      </div>
      {error && (
        <div
          role='alert'
          className={errorClassNames}
          data-testid='date-picker-error'
        >
          {error}
        </div>
      )}
    </div>
  )
}

export default DateInput
